var _rect, _rect2, _line, _circle, _circle2, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRaffle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 3,
    width: 18,
    height: 14,
    rx: 2,
    fill: "#B3BEC1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 3,
    width: 18,
    height: 5,
    rx: 2,
    fill: "#B3BEC1"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 3,
    x2: 10,
    y2: 17,
    stroke: "#1a1a2e",
    strokeWidth: 1.5,
    strokeDasharray: "2 2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 3,
    r: 2,
    fill: "#1a1a2e"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 17,
    r: 2,
    fill: "#1a1a2e"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 5.5,
    y: 13,
    fontFamily: "Arial",
    fontWeight: "bold",
    fontSize: 5,
    fill: "#1a1a2e",
    textAnchor: "middle"
  }, "\uD83C\uDF9F")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaffle);
export default __webpack_public_path__ + "static/media/raffle.6752160897c8b5e595cb3faea2c2f7b4.svg";
export { ForwardRef as ReactComponent };